import { PUBLIC_STORAGE_URL } from '@/constants/global'

export const SYMPTOMS = [
  {
    key: 'liquenificacao',
    label: 'Liquenificação (Pele grossa)',
    images_by_level: [
      {
        level: 0,
        image: PUBLIC_STORAGE_URL + '/paola-assets/espessamento/0.png',
      },
      {
        level: 1,
        image: PUBLIC_STORAGE_URL + '/paola-assets/espessamento/1.png',
      },
      {
        level: 2,
        image: PUBLIC_STORAGE_URL + '/paola-assets/espessamento/2.png',
      },
      {
        level: 3,
        image: PUBLIC_STORAGE_URL + '/paola-assets/espessamento/3.png',
      },
    ],
  },
  {
    key: 'eritema',
    label: 'Eritema (Vermelhidão)',
    images_by_level: [
      {
        level: 0,
        image: PUBLIC_STORAGE_URL + '/paola-assets/vermelhidao/0.png',
      },
      {
        level: 1,
        image: PUBLIC_STORAGE_URL + '/paola-assets/vermelhidao/1.png',
      },
      {
        level: 2,
        image: PUBLIC_STORAGE_URL + '/paola-assets/vermelhidao/2.png',
      },
      {
        level: 3,
        image: PUBLIC_STORAGE_URL + '/paola-assets/vermelhidao/3.png',
      },
    ],
  },
  {
    key: 'edema',
    label: 'Edema (Inchaço)',
    images_by_level: [
      {
        level: 0,
        image: PUBLIC_STORAGE_URL + '/paola-assets/inchaco/0.png',
      },
      {
        level: 1,
        image: PUBLIC_STORAGE_URL + '/paola-assets/inchaco/1.png',
      },
      {
        level: 2,
        image: PUBLIC_STORAGE_URL + '/paola-assets/inchaco/2.png',
      },
      {
        level: 3,
        image: PUBLIC_STORAGE_URL + '/paola-assets/inchaco/3.png',
      },
    ],
  },
  {
    key: 'exsudacao',
    label: 'Exsudação (Crostas)',
    images_by_level: [
      {
        level: 0,
        image: PUBLIC_STORAGE_URL + '/paola-assets/crosta/0.png',
      },
      {
        level: 1,
        image: PUBLIC_STORAGE_URL + '/paola-assets/crosta/1.png',
      },
      {
        level: 2,
        image: PUBLIC_STORAGE_URL + '/paola-assets/crosta/2.png',
      },
      {
        level: 3,
        image: PUBLIC_STORAGE_URL + '/paola-assets/crosta/3.png',
      },
    ],
  },
  {
    key: 'escoriacoes',
    label: 'Escoriações (Sinais de coceira)',
    images_by_level: [
      {
        level: 0,
        image: PUBLIC_STORAGE_URL + '/paola-assets/coceira/0.png',
      },
      {
        level: 1,
        image: PUBLIC_STORAGE_URL + '/paola-assets/coceira/1.png',
      },
      {
        level: 2,
        image: PUBLIC_STORAGE_URL + '/paola-assets/coceira/2.png',
      },
      {
        level: 3,
        image: PUBLIC_STORAGE_URL + '/paola-assets/coceira/3.png',
      },
    ],
  },
  {
    key: 'xerose',
    label: 'Xerose (Secura)',
    images_by_level: [
      {
        level: 0,
        image: PUBLIC_STORAGE_URL + '/paola-assets/secura/0.png',
      },
      {
        level: 1,
        image: PUBLIC_STORAGE_URL + '/paola-assets/secura/1.png',
      },
      {
        level: 2,
        image: PUBLIC_STORAGE_URL + '/paola-assets/secura/2.png',
      },
      {
        level: 3,
        image: PUBLIC_STORAGE_URL + '/paola-assets/secura/3.png',
      },
    ],
  },
]
